module.exports = __webpack_public_path__ + "assets/img/qb.950fc8de.png";